export enum ToastTypeEnum
{
    success = "toast-success",
    info = "toast-info",
    warning = "toast-warning",
    error = "toast-error"
}